export const msalConfig = {
  auth: {
  clientId: 'c5feb040-07f8-4846-b4bf-5daf6a7319b6',
  authority: 'https://login.microsoftonline.com/e11cbe9c-f680-44b9-9d42-d705f740b888',

  //clientId: process.env.REACT_APP_AZURE_CLIENT_ID ,
    //authority: process.env.REACT_APP_AZURE_AUTHORITY || `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
     navigateToLoginRequestUrl: false, 
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case 'Error':
            console.error(message);
            return;
          case 'Info':
            console.info(message);
            return;
          case 'Verbose':
            console.debug(message);
            return;
          case 'Warning':
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
  prompt: 'select_account'
};

export const tokenRequest = {
  scopes: ['User.Read'],
  forceRefresh: false,
};